// Mock data for DreamHousesUSA Landing Page

export const heroData = {
  companyName: "DreamHousesUSA",
  tagline: "Sell Your House Fast or Access Off-Market Deals",
  subtitle: "No agents. No repairs. No games. Trusted, fast, and professional."
};

export const howItWorksSteps = [
  {
    id: 1,
    title: "Submit Your Details",
    description: "Fill out our simple form with your property info (for sellers) or investment criteria (for buyers)."
  },
  {
    id: 2,
    title: "Get Your Offer",
    description: "We review and present a competitive cash offer or suitable off-market deals within 24 hours."
  },
  {
    id: 3,
    title: "Close on Your Timeline",
    description: "Accept our offer and close on a date that works for you. Simple contracts, no hidden fees."
  }
];

export const whoWeHelpList = [
  "Homeowners facing foreclosure or financial pressure",
  "Inherited properties that need quick sale",
  "Vacant or distressed homes",
  "Tired landlords ready to cash out",
  "Investors looking for off-market deals"
];

export const trustInfo = {
  title: "Trust & Transparency",
  paragraphs: [
    "DreamHousesUSA is a professional real estate investment company. We operate with honesty, clear communication, and simple contracts.",
    "We may purchase properties directly or offer them via assignment of contract or double closing. We are not a real estate brokerage."
  ]
};

export const contactInfo = {
  website: "www.dreamhousesusa.com",
  email: "info@dreamhousesusa.com",
  tagline: "Real Estate Investment Company | Not a Real Estate Brokerage | Equal Housing Opportunity"
};

export const disclaimer = "Disclaimer: DreamHousesUSA provides real estate investment services. We are not a real estate brokerage. All offers are subject to review and verification. Properties may be purchased directly or assigned to qualified investors. This website is for informational purposes only and does not constitute legal, financial, or investment advice. Always consult a licensed professional for specific guidance.";
